<template>
    <div class="row d-flex justify-content-center" style="height:55vh">
        <div class="col-12 col-sm-5">
            <Listbox
                v-model="selectedSrcItems"
                :options="sitems"
                :multiple="(pickOptions.source && pickOptions.source.multiple !== undefined) ? pickOptions.source.multiple : true"
                :filter="true"
                optionLabel="product_code"
                :filterPlaceholder="pickOptions.source && pickOptions.source.placeholder ? pickOptions.source.placeholder : ''"
                listStyle="max-height:44vh"
                style="height:100%"
            >
                <!-- :virtualScrollerOptions="vso" -->
                <template #header>
                    <div
                        class="p-2 bg-light text-end border-bottom"
                    >{{pickOptions.source && pickOptions.source.headerText ? pickOptions.source.headerText : ''}} {{sitems.length}}</div>
                </template>
                <template #option="slotProps">
                    <div class="d-flex align-items-center">
                        <img
                            :src="slotProps.option.image"
                            class="float-start me-2 img-circle-cover"
                        />
                        <div>{{slotProps.option.product_code}}</div>
                        <div class="ms-auto">
                            <span v-if="slotProps.option.quantity" class="px-3">
                                <b>{{TR.product_balance}}:</b>
                                {{slotProps.option.quantity}}
                            </span>
                            <InputNumber
                                v-model="sitems_value[slotProps.option.id]"
                                :min="1"
                                :max="slotProps.option.quantity ? slotProps.option.quantity : ''"
                                class="tl-input"
                                @click.stop.prevent=""
                            />
                                <!-- @change="changeCount($event)" -->
                        </div>
                    </div>
                </template>
                <template v-slot:loader="{ options }">
                    <div :class="['scroll-item p-2', {'odd': options.odd}]" style="height: 50px">
                        <Skeleton :width="options.even ? '60%' : '50%'" height="1.3rem" />
                    </div>
                </template>
            </Listbox>
        </div>
        <div
            class="col-12 col-sm-2 w-auto align-self-center d-sm-grid gap-sm-3"
        >
            <Button icon="fas fa-angle-right" @click="sendSrc" />
            <Button icon="fas fa-angle-double-right" @click="sendSrcAll" />
            <Button icon="fas fa-angle-left" @click="sendDest" />
            <Button icon="fas fa-angle-double-left" @click="sendDestAll" />
        </div>
        <div class="col-12 col-sm-5">
            <Listbox
                v-model="selectedDstItems"
                :options="ditems"
                :multiple="(pickOptions.destination && pickOptions.destination.multiple !== undefined) ? pickOptions.destination.multiple : true"
                :filter="true"
                optionLabel="product_code"
                :filterPlaceholder="pickOptions.destination && pickOptions.destination.placeholder ? pickOptions.destination.placeholder : ''"
                listStyle="max-height:44vh"
                style="height:100%"
            >
                <template #header>
                    <div
                        class="p-2 bg-light text-end border-bottom"
                    >{{pickOptions.destination && pickOptions.destination.headerText ? pickOptions.destination.headerText : ''}} {{ditems.length}}</div>
                </template>
                <template #option="slotProps">
                    <div class="d-flex align-items-center">
                        <img
                            :src="slotProps.option.image"
                            class="float-start me-2 img-circle-cover"
                        />
                        <div>{{slotProps.option.product_code}}</div>
                        <div class="ms-auto">
                            <InputNumber
                                v-model="ditems_value[slotProps.option.id]"
                                :min="1"
                                :max="slotProps.option.quantity ? slotProps.option.quantity : ''"
                                class="tl-input"
                                @click.stop.prevent
                            />
                            <!-- @click.stop.prevent="" -->
                        </div>
                    </div>
                </template>
            </Listbox>
        </div>
    </div>
</template>


<script>
    import { onMounted, ref, watchEffect } from "vue";

    import { useStore } from "@/system_modules/store";

    // import Dropdown from "primevue/dropdown";
    import Listbox from "primevue/listbox";
    import Button from "primevue/button";
    import InputNumber from "primevue/inputnumber";
    import Skeleton from "primevue/skeleton";
    // import VirtualScroller from "primevue/virtualscroller";

    import { useModelWrapper } from "@/system_modules/utils/modelWrapper";

    export default {
        name: "TransferList2",
        props: {
            source: {
                type: Object,
            },
            destination: {
                type: Object,
            },
            pickOptions: {
                type: Object,
                default: null,
            },
            mainref: {
                type: Object,
            },
        },
        // emits:["getData"],
        components: {
            // Dropdown,
            Listbox,
            Button,
            InputNumber,
            Skeleton,
            // VirtualScroller,
        },
        setup(props, { emit }) {
            const store = useStore();

            const TR = ref(null);

            const PO = useModelWrapper(props, emit, "mainref");

            const sitems = ref([]);
            const sitems_value = ref({});
            const ditems = ref([]);
            const ditems_value = ref({});

            const selectedSrcItems = ref([]);
            const selectedDstItems = ref([]);

            // // const scrollData = ref(0);
            // const lazyLoading = ref(false);
            // const vso = ref({
            //     // showLoader: true,
            //     // loading: lazyLoading.value,
            //     // itemSize: 50,
            //     // items: sitems.value,
            //     // lazy: false,
            //     // "lazy-load": onLazyLoad,
            // });

            // const onLazyLoad = (event) => {
            //     // const {first, last} = event;
            //     // console.log(first, last);
            //     // lazyLoading.value = true;
            //     // if( scrollData.value != first ){
            //     //     scrollData.value = scrollData.value + first;
            //     //     // sitems.value = props.source
            //     //     context.emit("getData", scrollData.value, last);
            //     // }
            //     // lazyLoading.value = false;
            // };

            watchEffect(() => {
                TR.value = store.getTranslation();
                PO.value["titems"] = ditems.value;
                PO.value["titems_value"] = ditems_value.value;
            });

            onMounted(() => {
                if (props.source.length) {
                    // sitems.value = sitems.value.concat(props.source);
                    sitems.value = props.source;
                    sitems.value.forEach((e) => {
                        sitems_value.value[e.id] = 1;
                    });
                }
                if (props.destination.length) {
                    ditems.value = props.destination;
                    ditems.value.forEach((e) => {
                        ditems_value.value[e.id] = 1;
                    });
                }
                // vso.value.items = sitems.value;
            });

            // const changeCount = (event) => {
            //     console.log(event);
            // };

            const sendSrc = () => {
                if (selectedSrcItems.value.length) {
                    ditems.value = ditems.value.concat(selectedSrcItems.value);
                    selectedSrcItems.value.forEach((e) => {
                        ditems_value.value[e.id] = sitems_value.value[e.id];
                        delete sitems_value.value[e.id];
                    });
                    if (sitems.value.length > selectedSrcItems.value.length)
                        selectedSrcItems.value.forEach((e) => {
                            sitems.value.forEach((a, i) => {
                                if (a.id == e.id) sitems.value.splice(i, 1);
                            });
                        });
                    else if (sitems.value.length == selectedSrcItems.value.length) {
                        sitems.value = [];
                        sitems_value.value = [];
                    }
                    selectedSrcItems.value = [];
                }
            };
            const sendSrcAll = () => {
                if (sitems.value.length) {
                    ditems.value = ditems.value.concat(sitems.value);
                    sitems.value.forEach((e) => {
                        ditems_value.value[e.id] = sitems_value.value[e.id];
                    });
                    // ditems.value = sitems.value;
                    sitems.value = [];
                    sitems_value.value = [];
                    selectedSrcItems.value = [];
                }
            };

            const sendDest = () => {
                if (selectedDstItems.value.length) {
                    sitems.value = sitems.value.concat(selectedDstItems.value);
                    selectedDstItems.value.forEach((e) => {
                        sitems_value.value[e.id] = ditems_value.value[e.id];
                        delete ditems_value.value[e.id];
                    });
                    if (ditems.value.length > selectedDstItems.value.length)
                        selectedDstItems.value.forEach((e) => {
                            ditems.value.forEach((a, i) => {
                                if (a.id == e.id) ditems.value.splice(i, 1);
                            });
                        });
                    else if (ditems.value.length == selectedDstItems.value.length) {
                        ditems.value = [];
                        ditems_value.value = [];
                    }
                    selectedDstItems.value = [];
                }
            };
            const sendDestAll = () => {
                if (ditems.value.length) {
                    sitems.value = sitems.value.concat(ditems.value);
                    ditems.value.forEach((e) => {
                        sitems_value.value[e.id] = ditems_value.value[e.id];
                    });
                    // sitems.value = ditems.value;
                    ditems.value = [];
                    ditems_value.value = [];
                    selectedDstItems.value = [];
                }
            };

            return {
                TR,
                selectedSrcItems,
                selectedDstItems,
                sitems,
                sitems_value,
                ditems,
                ditems_value,
                sendSrc,
                sendSrcAll,
                sendDest,
                sendDestAll,
                // vso,
                // lazyLoading,
                // onLazyLoad,
                // changeCount,
            };
        },
    };
</script>


<style lang="scss">
    .p-listbox .p-listbox-list .p-listbox-item.p-highlight {
        color: #ffffff;
        background: var(--bs-primary);
    }
    .tl-input > input {
        margin-right: 10px;
        width: 80px;
    }
    .form-check-input:checked ~ .fci-div {
        color: #ffffff;
        background-color: var(--bs-primary);
    }
</style>